import mime from 'mime'
import customFetch from '../../function/customFetch'
import { BASE_URL } from '../../api/config'
import getFileExtension from '../../function/getFileExtension'

interface GetUploadURLResponse {
  status: 'ok' | 'error'
  data: {
    description: string
    id: string
    status: 'success'
    upload_url: string
  }
  error?: string
}

const getUploadURL = async (
  file: File,
  assignmentId?: string | null,
  isAuthorized?: boolean
): Promise<any> => {
  try {
    let fileType = file.type || mime.getType(file.name)

    if (!fileType) {
      const fileExtension = getFileExtension(file.name)

      if (fileExtension === 'docx') {
        fileType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`
      }

      if (fileExtension === 'pdf') {
        fileType = `application/pdf`
      }
    }

    if (!fileType) {
      throw new Error(
        'File type is missing. Please upload a file with a valid type.'
      )
    }
    const authToken = localStorage.getItem('authToken')
    const publicAuthToken = localStorage.getItem('publicAuthToken')
    const isPublic = Boolean(isAuthorized === false && publicAuthToken)

    const headers = {
      Authorization: isPublic
        ? `Bearer ${publicAuthToken}`
        : `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
    const url = new URL(`${BASE_URL}/files/v2`)
    if (isPublic) url.searchParams.append('is_public', String(isPublic))
    const response = await customFetch(url.toString(), {
      method: 'POST',
      headers,
      body: JSON.stringify({
        file_size: file.size,
        file_name: file.name,
        file_type: fileType,
        ...(assignmentId && {
          assignment_id: assignmentId
        })
      })
    })
    const result = await response.json()
    if (response.ok) {
      return {
        status: 'ok',
        data: result,
        error: undefined
      }
    }
    throw new Error(result.description)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}

export default getUploadURL
